import { combineReducers } from "@reduxjs/toolkit";
// import fuse from "./fuse";
import user from "./userSlice";

const createReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    // fuse,
    user,
    ...asyncReducers,
  });

  /*
  Reset the redux store when user logged out
   */
  if (action.type === "user/userLoggedOut") {
    // state = undefined;
  }

  return combinedReducer(state, action);
};

export default createReducer;
